import React, { useEffect, useRef } from 'react'
import { partnerContentStore } from 'state/setting/partnerContent'
import '../styles/partners-preview.scss'
import noImageFound from 'assets/Images/No-image-found.jpeg'

const stripP = (html: string) => {
  if (!html) return ''
  return html.replace(/^<p>|<\/p>$/g, '')
}

const PartnersContentPreview: React.FC = () => {
  const { slides, currentSlide } = partnerContentStore()
  const cardRefs = useRef<{ [key: string | number]: HTMLDivElement | null }>({})

  const slidesToRender =
    slides.length > 0
      ? slides
      : [
          {
            id: 'placeholder',
            title: 'Partner title',
            content: 'Partner description goes here',
            coverPhotosIds: [],
            coverPhotoPreviewUrl: '',
            buttons: [{ text: '', link: '' }],
            layout: 'left',
          },
        ]

  // Scroll to active slide when currentSlide changes
  useEffect(() => {
    if (slides.length > 0 && slides[currentSlide]) {
      const activeSlideId = slides[currentSlide].id
      const activeCard = cardRefs.current[activeSlideId]
      if (activeCard) {
        activeCard.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        })
      }
    }
  }, [currentSlide, slides])

  return (
    <div className="partners-preview-wrapper">
      <div className="partners-preview-scroll">
        {slidesToRender.map((slide, index) => {
          const cleanedTitle = stripP(slide.title)
          const cleanedContent = stripP(slide.content)
          const isReversed = slide.layout === 'right' // Use layout field instead of index
          const isActive =
            slides.length > 0 && slides[currentSlide]?.id === slide.id

          return (
            <div
              key={slide.id}
              ref={el => {
                cardRefs.current[slide.id] = el
              }}
              className={`partners-preview-card ${
                isReversed ? 'reversed' : ''
              } ${isActive ? 'active-slide' : ''}`}
            >
              <div className="content">
                <div className="partners-preview-title">
                  <div
                    className="partners-preview-title-html"
                    dangerouslySetInnerHTML={{ __html: cleanedTitle }}
                  />
                </div>

                <div className="partners-preview-content">
                  <div
                    className="partners-preview-content-html"
                    dangerouslySetInnerHTML={{ __html: cleanedContent }}
                  />
                </div>

                <div className="partners-preview-buttons">
                  {slide.buttons?.map(
                    (btn, idx) =>
                      btn?.text && (
                        <a
                          key={idx}
                          href={btn.link || '#'}
                          target="_blank"
                          rel="noreferrer"
                        >
                          <button className="partners-preview-button">
                            {btn.text}
                          </button>
                        </a>
                      ),
                  )}
                </div>
              </div>

              <div className="image">
                <div className="partners-cover-image">
                  <img
                    src={slide.coverPhotoPreviewUrl || noImageFound}
                    alt="partner-cover"
                  />
                </div>
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default PartnersContentPreview
